import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function BonusSection() {
  const bonuses = [{
    icon: '📊',
    title: 'Planificador de Sueño del Bebé',
    desc: 'Registro diario de siestas y sueño nocturno, seguimiento de despertares y checklist de rutina nocturna. Deja de adivinar y empieza a ajustar con claridad.',
    value: '$17'
  }, {
    icon: '🚨',
    title: 'Guía de Supervivencia — Regresiones',
    desc: 'Qué hacer exactamente a los 4, 8 y 12 meses cuando todo parece ir hacia atrás. Sin perder el progreso que ya lograste.',
    value: '$27'
  }, {
    icon: '✅',
    title: 'Checklist: La Habitación Perfecta',
    desc: '5 ajustes en el ambiente que inducen el sueño profundo de inmediato. Temperatura, luz, sonido y seguridad en una lista aplicable hoy mismo.',
    value: '$12'
  }];
  return <section className="py-16 md:py-24 px-4 md:px-6 bg-navy" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <FadeIn data-id="element-3">
          <div className="text-center mb-16" data-id="element-4">
            <div className="inline-block bg-navy-light border border-white/10 text-white/80 font-medium text-xs md:text-sm px-4 py-1.5 rounded-full mb-6 uppercase tracking-wider" data-id="element-5">
              Incluido en tu compra
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white leading-tight mb-5" data-id="element-6">
              Más que un método.
              <br data-id="element-7" />
              Un <span className="text-gold italic" data-id="element-8">sistema completo.</span>
            </h2>
            <p className="text-lg text-white/70 max-w-2xl mx-auto leading-relaxed" data-id="element-9">
              Porque no basta con leer — necesitas herramientas para aplicar y
              ver el progreso.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-10">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-11">
              <div className="bg-gradient-to-br from-[#1A2F5E] to-navy-light rounded-2xl p-8 border border-white/10 relative overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-lg h-full" data-id="element-12">
                {/* Bonus Ribbon */}
                <div className="absolute top-4 -right-8 bg-gold text-navy text-[10px] font-black tracking-widest px-10 py-1 rotate-45 shadow-md" data-id="element-13">
                  BONUS
                </div>

                <div className="text-4xl mb-4" data-id="element-14">{bonus.icon}</div>
                <h3 className="font-serif text-lg font-bold text-white mb-2" data-id="element-15">
                  {bonus.title}
                </h3>
                <p className="text-sm text-white/70 leading-relaxed mb-4" data-id="element-16">
                  {bonus.desc}
                </p>
                <div className="text-sm font-bold text-rose" data-id="element-17">
                  <span className="line-through text-white/40 font-normal mr-1" data-id="element-18">
                    Valor {bonus.value}
                  </span>
                  GRATIS con tu compra
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}